import { useEffect } from 'react';
import { useDispatch, useSelector } from '@shared/store';
import { fetchLinkData } from './actions';

export function useLinkData(url: string): LinkData | undefined {
  const dispatch = useDispatch();
  const link: LinkData | undefined = useSelector(state => state.linkData[url]);

  useEffect(() => {
    dispatch(fetchLinkData(url));
  }, [dispatch, url]);

  return link;
}
